import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { ContentStackItem, ContentStackService } from '@app/core/_services/content-stack.service'
import { RpTimeslotPartnersComponent } from '@app/right-panel/components/rp-timeslot-partners/rp-timeslot-partners.component'
import { FmAvatarComponent } from '@app/shared/components/fm-avatar/fm-avatar.component'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { ProfilePreviewComponent } from '../../../user/components/profile-preview/profile-preview.component'
import { TooltipModule } from 'primeng/tooltip'
import { CalendarDayAvailablePartner } from '../calendar-day/calendar-day.component'
import { ButtonModule } from 'primeng/button'

@Component({
    selector: 'fm-available-partner-tile',
    imports: [
        TooltipModule,
        ButtonModule,
        FontAwesomeModule,
        CommonModule,
        FmAvatarComponent,
        ProfilePreviewComponent,
    ],
    templateUrl: './available-partner-tile.component.html',
    styleUrl: './available-partner-tile.component.scss',
})
export class AvailablePartnerTileComponent {
    @Input() partnerInfo: CalendarDayAvailablePartner
    @Input() validPartner: boolean
    @Input() sessionTime: number
    @Input() sessionDuration: number
    @Input() profilePhoto: string
    @Input() profileSlug: string
    @Input() isSaved: boolean = false
    @Input() isQuietMode: boolean = false
    @Input() hasDirectBookablePartner: boolean = false
    @Input() isSelectable: boolean

    tooltipOptions = {
        showDelay: 0,
        autoHide: false,
        tooltipEvent: 'hover',
        tooltipPosition: 'left',
        tooltipStyleClass: 'profile-preview',
        hideDelay: 75,
    }

    constructor(private contentStackService: ContentStackService) {}

    public onClickSendTimeslotPartnersToDynamicPanel(): void {
        const stackItem: ContentStackItem = {
            component: RpTimeslotPartnersComponent,
            context: {
                sessionTime: this.partnerInfo.sessionTime,
                sessionDuration: this.partnerInfo.sessionDuration,
            },
            popIfCovered: true,
            preserveStack: false,
            showRefreshButton: false,
        }
        this.contentStackService.pushContent(stackItem)
    }

    onProfilePreviewMouseLeave(e) {
        this.tooltipOptions = { ...this.tooltipOptions, hideDelay: 200 }
    }

    onProfilePreviewMouseEnter(e) {
        // In case someone very briefly hovers outside of the avatar in route to the
        // profile preview, reset the timeout on entering the preview so that the tooltip
        // does not get removed
        this.tooltipOptions = {
            ...this.tooltipOptions,
            hideDelay: 200000,
        }
    }
}
